var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCounselDetailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 54,
    viewBox: "0 0 48 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6281 0.316406H0.516602V41.1239H33.6281V0.316406Z",
    fill: "#00237D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.922 4.52979H4.81055V45.3372H37.922V4.52979Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75391 2.49219H39.9782V47.3758H2.75391V2.49219ZM6.86673 6.56829V43.2996H35.8654V6.56829H6.86673Z",
    fill: "#002FA7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3751 8.66748H10.2637V49.475H43.3751V8.66748Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20801 6.62988H45.4323V51.5135H8.20801V6.62988ZM12.3208 10.706V47.4374H41.3195V10.706H12.3208Z",
    fill: "#002FA7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3429 12.8813H14.2314V53.6888H47.3429V12.8813Z",
    fill: "#002FA7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1921 19.5811H25.0645V22.2351H42.1921V19.5811Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1919 25.8164H19.999V28.4705H42.1919V25.8164Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1919 32.0518H19.999V34.7058H42.1919V32.0518Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1919 38.2876H19.999V40.9417H42.1919V38.2876Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1919 44.5229H19.999V47.177H42.1919V44.5229Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounselDetailIcon);
export default __webpack_public_path__ + "static/media/counselDetailIcon.6b3d3bf7309ad071a8f2f7e0bdfcdb43.svg";
export { ForwardRef as ReactComponent };